import React from "react";

function Footer() {
  return (
    <footer>
      <p className="m-0 text-center copyRight">
        Copyright © Saveurs jamaicaines 2020
      </p>
    </footer>
  );
}

export default Footer;
